<template>
  <div>
    <div class="row">
      <div v-if="!isReiseOhneFlugComputed" class="col-md-12">
        <ReiseterminViewCardFlugdaten :reiseterminObj="reiseterminObj"></ReiseterminViewCardFlugdaten>
      </div>
      <div class="col-md-6">
        <ReiseterminCardAufgaben :reiseterminObj="reiseterminObj"></ReiseterminCardAufgaben>
      </div>
      <div class="col-md-6">
        <template v-if="reiseterminObj">
          <ReiseterminComments
            :reiseterminId="reiseterminObj.id"
            :comments="getCommentsWithMappedAnswers"
            :showDepartmentButtons="true"
            :departmentsOfCommentCreators="departmentsOfCommentCreators"
            :selectedDepartment="selectedDepartment"
            :hideEmojis="true"
            @updateComments="onUpdateComments"
            @changeDepartment="changeDepartment"
          />
        </template>
        <template v-else>
          <div class="card">
            <div class="card-header">
              <b-skeleton class="m-auto" height="100%" width="100%"></b-skeleton>
            </div>
            <div class="card-body">
              <b-skeleton class="m-auto" height="200px" width="100%"></b-skeleton>
            </div>
          </div>
        </template>
      </div>

      <div class="col-md-12 gutter-b" id="reiseterminCardVorgaengeDetails">
        <template v-if="reiseterminObj">
          <div>
            <ReiseterminCardVorgaengeDetails
              :defaultTab="2"
              :reiseterminObj="reiseterminObj"
              :isReiseterminInReleasePruefung="isReiseterminInReleasePruefung || isInTransferplanung"
              :isInTransferplanung="isInTransferplanung"
              :gueltigeKonfiguration="reiseterminObj?.gueltigeKonfiguration"
            ></ReiseterminCardVorgaengeDetails>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.more-btn {
  cursor: pointer;
}
</style>

<script>
import ReiseterminCardVorgaengeDetails from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-details.vue';
import ReiseterminViewCardFlugdaten from '@/components/produkte/reisetermine/reisetermin-card-flugdata.vue';
import ReiseterminCardAufgaben from '@/components/produkte/reisetermine/reisetermin-card-aufgaben.vue';
import ReiseterminComments from '@/components/comments/reisetermin-comments.vue';
import { mapState } from 'vuex';
import {
  filterCommentsByDepartment,
  isReiseOhneFlug,
  departmentButtonClass,
} from '@/core/common/helpers/utils';

export default {
  name: 'ReisetermineViewComponent',
  components: {
    ReiseterminCardVorgaengeDetails,
    ReiseterminViewCardFlugdaten,
    ReiseterminCardAufgaben,
    ReiseterminComments,
  },
  props: {
    reiseterminObj: Object,
  },
  data() {
    return {
      selectedDepartment: null,
    };
  },
  watch: {
    reiseterminObj() {
      if (this.$route.fullPath.includes('releasepruefung')) {
        if (this.departmentsOfCommentCreators.includes('Destination Operations Management')) {
          this.selectedDepartment = 'DOM';
        } else {
          this.selectedDepartment = null;
        }
      }
    },
  },
  mounted() {
    if (this.$route.fullPath.includes('releasepruefung')) {
      if (this.departmentsOfCommentCreators.includes('Destination Operations Management')) {
        this.selectedDepartment = 'DOM';
      } else {
        this.selectedDepartment = null;
      }
    }
  },
  computed: {
    ...mapState({
      users: state => state.users['users'],
    }),
    filteredComments() {
      return filterCommentsByDepartment(this.reiseterminObj?.comments, this.selectedDepartment, this.users);
    },
    departmentsOfCommentCreators() {
      // überprüfung, ob das comments array leer ist
      if (this.reiseterminObj?.comments?.length === 0) {
        return [];
      } else {
        // es werden sich alle creator aus den kommentaren geholt -> geht über das gesamte array von Objects
        // ergebnis ist ein neues array mit den IDs
        const creatorIds = this.reiseterminObj?.comments.map(comment => comment.creator);

        // geht über das users Array und überprüft, ob die ID in dem creators array enthalten ist
        const usersList = this.users.filter(user => creatorIds.includes(user.id));

        // geht über jedes usersList array und nimmt sich da dann das department heraus
        const departments = usersList.map(user => user.department);
        // Dedupliziert den department button, wenn ein Reisetermin "Customer Operations- und Success Management" Kommentare hat
        const geseheneLabels = new Set();
        return departments.filter(department => {
          const label = departmentButtonClass(department).label ?? department;
          if (geseheneLabels.has(label)) {
            return false;
          }
          geseheneLabels.add(label);
          return true;
        });
      }
    },
    getCommentsWithMappedAnswers() {
      if (!this.reiseterminObj || !this.reiseterminObj.comments?.length > 0) {
        return [];
      }

      const answers = this.filteredComments.filter(comment => comment.parentId !== null);
      const commentsWithAnswers = this.filteredComments
        .filter(comment => comment.parentId === null)
        .map(comment => {
          const matchingAnswers = answers.filter(answer => answer.parentId === comment.id);
          if (matchingAnswers.length > 0) {
            return { ...comment, answers: matchingAnswers };
          } else return { ...comment, answers: [] };
        })
        .sort((a, b) => new Date(b.createdDateUtc) - new Date(a.createdDateUtc));
      return commentsWithAnswers;
    },
    isReiseOhneFlugComputed() {
      return isReiseOhneFlug(this.reiseterminObj?.metadata);
    },
    isReiseterminInReleasePruefung() {
      return this.reiseterminObj?.state === 'Aufgelegt';
    },
    isInTransferplanung() {
      return this.reiseterminObj?.state === 'Aufgelegt';
    },
  },
  methods: {
    onUpdateComments(res) {
      this.reiseterminObj.comments = res.comments;
    },
    changeDepartment(departmentLabel) {
      this.selectedDepartment = this.selectedDepartment === departmentLabel ? null : departmentLabel;
    },
  },
};
</script>
